import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListDetectionIdsVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ListDetectionsInput>;
}>;

export type ListDetectionIds = {
  detections: {
    detections: Array<
      Pick<Types.CorrelationRule, 'id'> | Pick<Types.Policy, 'id'> | Pick<Types.Rule, 'id'>
    >;
    paging: Pick<Types.PagingData, 'totalPages' | 'thisPage' | 'totalItems'>;
  };
};

export const ListDetectionIdsDocument = gql`
  query ListDetectionIds($input: ListDetectionsInput) {
    detections(input: $input) {
      detections {
        ... on Rule {
          id
        }
        ... on CorrelationRule {
          id
        }
        ... on Policy {
          id
        }
      }
      paging {
        totalPages
        thisPage
        totalItems
      }
    }
  }
`;

/**
 * __useListDetectionIds__
 *
 * To run a query within a React component, call `useListDetectionIds` and pass it any options that fit your needs.
 * When your component renders, `useListDetectionIds` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDetectionIds({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListDetectionIds(
  baseOptions?: Apollo.QueryHookOptions<ListDetectionIds, ListDetectionIdsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDetectionIds, ListDetectionIdsVariables>(
    ListDetectionIdsDocument,
    options,
  );
}
export function useListDetectionIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDetectionIds, ListDetectionIdsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDetectionIds, ListDetectionIdsVariables>(
    ListDetectionIdsDocument,
    options,
  );
}
export function useListDetectionIdsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDetectionIds, ListDetectionIdsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDetectionIds, ListDetectionIdsVariables>(
    ListDetectionIdsDocument,
    options,
  );
}
export type ListDetectionIdsHookResult = ReturnType<typeof useListDetectionIds>;
export type ListDetectionIdsLazyQueryHookResult = ReturnType<typeof useListDetectionIdsLazyQuery>;
export type ListDetectionIdsSuspenseQueryHookResult = ReturnType<
  typeof useListDetectionIdsSuspenseQuery
>;
export type ListDetectionIdsQueryResult = Apollo.QueryResult<
  ListDetectionIds,
  ListDetectionIdsVariables
>;
export function mockListDetectionIds({
  data,
  variables,
  errors,
}: {
  data: ListDetectionIds;
  variables?: ListDetectionIdsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ListDetectionIdsDocument, variables },
    result: { data, errors },
  };
}
